<mat-dialog-content class="sisalto-alue">
  <div class="kuvitus">
    <svg viewBox="0 0 640 168" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="566" cy="14" r="96" fill="#cbeafa"></circle>
      <circle cx="46" cy="178" r="66" fill="#47b8f1"></circle>
      <circle cx="46" cy="178" r="50" fill="#f2fbff"></circle>
      <g transform="translate(40 0)">
        <g transform="rotate(9 320 90)">
          <rect x="278" y="26" width="98" height="120" rx="4" fill="#bfe4f7"></rect>
        </g>
        <g transform="rotate(-6 268 88)">
          <path d="M220 30 h96 v106 l-8 -6 -8 6 -8 -6 -8 6 -8 -6 -8 6 -8 -6 -8 6 -8 -6 -8 6 -8 -6 -8 6 Z" fill="#ffffff"></path>
          <rect x="232" y="44" width="46" height="7" rx="3.5" fill="#c7cfd6"></rect>
          <rect x="232" y="60" width="72" height="5" rx="2.5" fill="#dde4ea"></rect>
          <rect x="232" y="72" width="72" height="5" rx="2.5" fill="#dde4ea"></rect>
          <rect x="232" y="84" width="56" height="5" rx="2.5" fill="#dde4ea"></rect>
          <rect x="232" y="100" width="34" height="8" rx="4" fill="#f6e14b"></rect>
          <rect x="272" y="100" width="32" height="8" rx="4" fill="#47b8f1"></rect>
          <rect x="232" y="116" width="72" height="6" rx="3" fill="#c7cfd6"></rect>
        </g>
        <circle cx="352" cy="110" r="27" fill="#ffffff" fill-opacity="0.45" stroke="#1e88c0" stroke-width="6"></circle>
        <line x1="372" y1="130" x2="394" y2="152" stroke="#1e88c0" stroke-width="8" stroke-linecap="round"></line>
        <path transform="translate(196 44)" d="M0,-11 C1.8,-3.6 3.6,-1.8 11,0 C3.6,1.8 1.8,3.6 0,11 C-1.8,3.6 -3.6,1.8 -11,0 C-3.6,-1.8 -1.8,-3.6 0,-11 Z" fill="#f6e14b"></path>
        <path transform="translate(404 40)" d="M0,-8 C1.3,-2.6 2.6,-1.3 8,0 C2.6,1.3 1.3,2.6 0,8 C-1.3,2.6 -2.6,1.3 -8,0 C-2.6,-1.3 -1.3,-2.6 0,-8 Z" fill="#47b8f1"></path>
        <path transform="translate(232 148)" d="M0,-6 C1,-2 2,-1 6,0 C2,1 1,2 0,6 C-1,2 -2,1 -6,0 C-2,-1 -1,-2 0,-6 Z" fill="#f6e14b"></path>
      </g>
    </svg>
    <button type="button" class="sulje-button" mat-dialog-close [attr.aria-label]="'tositteet.uudistus.sulje' | translate | async">
      <span class="material-symbols-outlined sulje-ikoni" aria-hidden="true">close</span>
    </button>
  </div>

  <div class="sisalto">
    <span class="uutta-pilleri">{{ 'tositteet.uudistus.uutta' | translate | async }}</span>
    <h1 class="otsikko">{{ 'tositteet.uudistus.otsikko' | translate | async }}</h1>
    <p class="johdanto">{{ 'tositteet.uudistus.johdanto' | translate | async }}</p>

    <div class="ominaisuudet">
      @for (ominaisuus of ominaisuudet; track ominaisuus.avain) {
        <div class="ominaisuus">
          <div class="ominaisuus-ikoni">
            <span class="material-symbols-outlined" aria-hidden="true">{{ ominaisuus.ikoni }}</span>
          </div>
          <div>
            <div class="ominaisuus-otsikko">{{ 'tositteet.uudistus.ominaisuudet.' + ominaisuus.avain + '.otsikko' | translate | async }}</div>
            <div class="ominaisuus-kuvaus">{{ 'tositteet.uudistus.ominaisuudet.' + ominaisuus.avain + '.kuvaus' | translate | async }}</div>
          </div>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="button" class="jatka-button" mat-dialog-close>{{ 'yleiset.ok' | translate | async }}</button>
</mat-dialog-actions>
